import {
  CLEAR_ON_CHANGE_PAYLOAD,
  DebounceStackAction,
  DebounceStackState,
  FORCE_WITH_VALUE,
  RESET_FLAGS,
  SET_VALUE,
  SYNC_FROM_PARENT,
  UPDATE_INDEX,
} from "./interface";

/**
 * Reducer function for managing debounce stack state
 *
 * @param state - The current state
 * @param action - The action to perform
 * @returns The new state
 */
export function debounceStackReducer<T>(
  state: DebounceStackState<T>,
  action: DebounceStackAction<T>,
): DebounceStackState<T> {
  switch (action.operation) {
    case SET_VALUE: {
      let newStack = [...state.stack];
      let newIndex = state.index;
      const comparisonChanged = action.payload.addToStack;
      if (action.payload.addToStack) {
        // Add to stack - comparison detected a change
        newIndex = state.index + 1;
        newStack = [...state.stack.slice(0, newIndex), action.payload.newValue];
      } else {
        // Update current value in place - comparison matched
        newStack[state.index] = action.payload.newValue;
      }
      return {
        stack: newStack,
        index: newIndex,
        changed: true,
        comparisonChanged,
        onChangePayload: { value: newStack[newIndex], index: newIndex, stack: newStack },
      };
    }
    case UPDATE_INDEX:
      return {
        ...state,
        index: action.payload.index,
        changed: true,
        comparisonChanged: true,
        onChangePayload: {
          value: state.stack[action.payload.index],
          index: action.payload.index,
          stack: state.stack,
        },
      };
    case RESET_FLAGS:
      return {
        ...state,
        changed: false,
        comparisonChanged: false,
      };
    case SYNC_FROM_PARENT: {
      let newStack = [...state.stack];
      let newIndex = state.index;
      if (action.payload.addToStack) {
        // Add to stack - comparison detected a change
        newIndex = state.index + 1;
        newStack = [...state.stack.slice(0, newIndex), action.payload.newValue];
      } else {
        // Update current value in place - comparison matched
        newStack[state.index] = action.payload.newValue;
      }
      return {
        stack: newStack,
        index: newIndex,
        changed: false,
        comparisonChanged: false,
        onChangePayload: action.payload.triggerOnChange
          ? { value: newStack[newIndex], index: newIndex, stack: newStack }
          : null,
      };
    }
    case FORCE_WITH_VALUE: {
      let newStack = [...state.stack];
      let newIndex = state.index;
      if (action.payload.addToStack) {
        // Add to stack - comparison detected a change
        newIndex = state.index + 1;
        newStack = [...state.stack.slice(0, newIndex), action.payload.newValue];
      } else {
        // Update current value in place - comparison matched
        newStack[state.index] = action.payload.newValue;
      }
      return {
        stack: newStack,
        index: newIndex,
        changed: false,
        comparisonChanged: false,
        onChangePayload: action.payload.triggerOnChange
          ? { value: newStack[newIndex], index: newIndex, stack: newStack }
          : null,
      };
    }
    case CLEAR_ON_CHANGE_PAYLOAD:
      return {
        ...state,
        onChangePayload: null,
      };
  }
}
